import { Link } from 'react-router-dom';
import styled from '@emotion/styled';

export const Logo = styled(Link)`
  color: #fff;

  & span {
    color: ${({ theme }) => theme.colors.DarkYellow};
  }
`;
